import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/logo.svg'


import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const drawer = ref(false)

// 上部メニューのルートリスト
const topMenuRoutes = [
  '/president_greeting',
  '/staff_voice',
  '/business',
  '/company',
  '/toiawase',
  '/accessmap'
]

// 現在のルートが上部メニューに属するかどうか
const isTopMenuActive = computed(() => {
  return topMenuRoutes.includes(route.path)
})

const navLists = ref([
  {
    name: 'ホーム',
    icon: 'mdi-home',
    link: '/',
    active: false
  },
  {
    name: '新着情報',
    icon: 'mdi-newspaper-variant',
    link: '/news',
    active: false
  },
  {
    name: '電子部品',
    icon: 'mdi-chip',
    active: false,
    lists: [
      {
        name: '電子部品',
        link: '/electronics'
      },
      {
        name: '注目の電子部品',
        link: '/electronics_focus'
      },
      {
        name: '部品在庫検索',
        link: '/search'
      },
      {
        name: '取引メーカー',
        link: '/maker'
      }
    ]
  },
  {
    name: '光通信関連部品',
    icon: 'mdi-cable-data',
    active: false,
    lists: [
      {
        name: '在庫一覧',
        link: '/opt_stock'
      },
      {
        name: '光アッテネータ',
        link: '/attenuator'
      },
      {
        name: '光パッチコード在庫検索',
        link: '/opt_search'
      },
      {
        name: '光パッチコードカスタムオーダー',
        link: '/opt_custom_order'
      },
      {
        name: '光アダプタ',
        link: '/adapter'
      },
      {
        name: '光コネクタ',
        link: '/opt_connector'
      },
      {
        name: 'アクセサリ',
        link: '/accessories'
      }
    ]
  },
  {
    name: '精密切削加工',
    icon: 'mdi-screwdriver',
    link: '/component',
    active: false
  },
  {
    name: '代表ご挨拶',
    icon: 'mdi-account-tie',
    link: '/president_greeting',
    active: false
  },
  {
    name: 'スタッフの声',
    icon: 'mdi-account-multiple',
    link: '/staff_voice',
    active: false
  },
  {
    name: 'お問い合わせ',
    icon: 'mdi-phone',
    link: '/toiawase',
    active: false
  },
  {
    name: 'アクセスマップ',
    icon: 'mdi-map-marker',
    link: '/accessmap',
    active: false
  }
])

const createTitleDesc = (routeInstance: any) => {
  const baseTitle = '株式会社東京アドコム - 電子部品関連、光通信関連部品、精密度加工部品'
  const baseDesc = '私たち東京アドコムは電子部品関連、光通信関連部品、精密度加工部品を中心に、その他新製品や終息品などの入手困難品も独自のルートからお探しいたします。是非、御社のビジネスパートナーとして御利用ください。'
  
  const title = routeInstance.meta.title 
    ? `${routeInstance.meta.title} | ${baseTitle}`
    : baseTitle
    
  const description = routeInstance.meta.desc
    ? `${routeInstance.meta.desc}${baseDesc}`
    : baseDesc

  useHead({
    title,
    meta: [
      { name: 'description', content: description }
    ]
  })
}

const menuClose = () => {
  navLists.value.forEach((navList) => (navList.active = false))
}

onMounted(() => {
  createTitleDesc(route)
})

watch(route, (newRoute) => {
  createTitleDesc(newRoute)
})

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("header", null, [
        _createVNode(_component_v_app_bar, {
          app: "",
          style: {"background-color":"#fff"}
        }, {
          extension: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              "show-arrows": "",
              grow: "",
              class: _normalizeClass(["custom-tabs bottom-tabs", { 'inactive-tabs': isTopMenuActive.value }]),
              "slider-color": "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { to: "/" }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("b", null, "ホーム", -1)
                  ])),
                  _: 1,
                  __: [12]
                }),
                _createVNode(_component_v_tab, { to: "/news" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("b", null, "新着情報", -1)
                  ])),
                  _: 1,
                  __: [13]
                }),
                _createVNode(_component_v_tab, { to: "/electronics" }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createElementVNode("b", null, "電子部品", -1)
                  ])),
                  _: 1,
                  __: [14]
                }),
                _createVNode(_component_v_tab, {
                  to: "/electronics_focus",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createElementVNode("b", null, "注目の電子部品", -1)
                  ])),
                  _: 1,
                  __: [15]
                }),
                _createVNode(_component_v_tab, {
                  to: "/search",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createElementVNode("b", null, "部品在庫検索", -1)
                  ])),
                  _: 1,
                  __: [16]
                }),
                _createVNode(_component_v_tab, {
                  to: "/maker",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createElementVNode("b", null, "取引メーカー", -1)
                  ])),
                  _: 1,
                  __: [17]
                }),
                _createVNode(_component_v_tab, { to: "/networking" }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createElementVNode("b", null, "光通信関連部品", -1)
                  ])),
                  _: 1,
                  __: [18]
                }),
                _createVNode(_component_v_tab, {
                  to: "/opt_stock",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createElementVNode("b", null, "在庫一覧", -1)
                  ])),
                  _: 1,
                  __: [19]
                }),
                _createVNode(_component_v_tab, {
                  to: "/attenuator",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("b", null, "光アッテネーター", -1)
                  ])),
                  _: 1,
                  __: [20]
                }),
                _createVNode(_component_v_tab, {
                  to: "/opt_search",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("b", null, [
                      _createTextVNode("光パッチコード"),
                      _createElementVNode("br"),
                      _createTextVNode("在庫検索")
                    ], -1)
                  ])),
                  _: 1,
                  __: [21]
                }),
                _createVNode(_component_v_tab, {
                  to: "/opt_custom_order",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createElementVNode("b", null, [
                      _createTextVNode("光パッチコード"),
                      _createElementVNode("br"),
                      _createTextVNode("カスタムオーダー")
                    ], -1)
                  ])),
                  _: 1,
                  __: [22]
                }),
                _createVNode(_component_v_tab, {
                  to: "/adapter",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("b", null, "光アダプタ", -1)
                  ])),
                  _: 1,
                  __: [23]
                }),
                _createVNode(_component_v_tab, {
                  to: "/opt_connector",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createElementVNode("b", null, "光コネクタ", -1)
                  ])),
                  _: 1,
                  __: [24]
                }),
                _createVNode(_component_v_tab, {
                  to: "/accessories",
                  style: {"font-size":"0.6em"}
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createElementVNode("b", null, "アクセサリ", -1)
                  ])),
                  _: 1,
                  __: [25]
                }),
                _createVNode(_component_v_tab, { to: "/component" }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createElementVNode("b", null, "精密切削加工", -1)
                  ])),
                  _: 1,
                  __: [26]
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_app_bar_nav_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = true))
            }),
            _createVNode(_component_v_toolbar_title, { style: {"padding":"0 10px 0 0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: _imports_0,
                  height: "40",
                  width: "120",
                  contain: ""
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_tabs, {
              class: _normalizeClass(["d-none d-md-flex custom-tabs top-tabs", { 'inactive-tabs': !isTopMenuActive.value }]),
              "slider-color": "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  to: "/president_greeting",
                  style: {"font-size":"0.8em"}
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("b", null, "代表ご挨拶", -1)
                  ])),
                  _: 1,
                  __: [2]
                }),
                _createVNode(_component_v_tab, {
                  to: "/staff_voice",
                  style: {"font-size":"0.8em"}
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("b", null, "スタッフの声", -1)
                  ])),
                  _: 1,
                  __: [3]
                }),
                _createVNode(_component_v_tab, {
                  to: "/business",
                  style: {"font-size":"0.8em"}
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("b", null, "事業内容", -1)
                  ])),
                  _: 1,
                  __: [4]
                }),
                _createVNode(_component_v_tab, {
                  to: "/company",
                  style: {"font-size":"0.8em"}
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("b", null, "会社情報", -1)
                  ])),
                  _: 1,
                  __: [5]
                }),
                _createVNode(_component_v_tab, {
                  to: "/toiawase",
                  style: {"font-size":"0.8em"}
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("b", null, "お問い合わせ", -1)
                  ])),
                  _: 1,
                  __: [6]
                }),
                _createVNode(_component_v_tab, {
                  to: "/accessmap",
                  style: {"font-size":"0.8em"}
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("b", null, "アクセスマップ", -1)
                  ])),
                  _: 1,
                  __: [7]
                })
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_btn, {
              flat: "",
              class: "bg-blue ma-2 text-white d-none d-md-flex",
              to: "/opt_search"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-magnify", -1)
                  ])),
                  _: 1,
                  __: [8]
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" 光パッチコード在庫検索", -1))
              ]),
              _: 1,
              __: [9]
            }),
            _createVNode(_component_v_btn, {
              flat: "",
              class: "bg-blue ma-2 text-white",
              to: "/search"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-magnify", -1)
                  ])),
                  _: 1,
                  __: [10]
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" 電子部品検索 ", -1))
              ]),
              _: 1,
              __: [11]
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_navigation_drawer, {
          modelValue: drawer.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
          temporary: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              nav: "",
              density: "compact"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLists.value, (navList) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: navList.name
                  }, [
                    (!navList.lists)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          to: navList.link,
                          onClick: menuClose
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(navList.icon), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(navList.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 1,
                          modelValue: navList.active,
                          "onUpdate:modelValue": ($event: any) => ((navList.active) = $event)
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props), {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(navList.icon), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(navList.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.lists, (list) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: list.name,
                                to: list.link
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(list.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, { app: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            flat: "",
            tile: "",
            width: "100%",
            class: "text-center",
            style: {"background-color":"#707070"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    to: "/privacy",
                    class: "text-white",
                    variant: "text"
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode("プライバシーポリシー", -1)
                    ])),
                    _: 1,
                    __: [27]
                  }),
                  _createTextVNode(" |   " + _toDisplayString(new Date().getFullYear()) + " ", 1),
                  _cache[28] || (_cache[28] = _createElementVNode("strong", null, "(c) Tokyo Adcom Corporation. All Rights Reserved. ", -1))
                ]),
                _: 1,
                __: [28]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})